export const WAREHOUSES_LIMITS_PAGE_NAMESPACE = 'warehouses-limits';
